export default {
    //本机测试 
    // 'BASEURL' : 'http://127.0.0.1:3007',
    //部署到服务器时接口
    'BASEURL' : 'http://146.56.247.36:3007',
    'baidu_map_ak':'rfGZCgZ6ExWlGXC4MLUMaFb2T9fgGSnZ',
}